import { Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private renderer: Renderer2;

  constructor(
    private translateService: TranslateService,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.initializeLanguageListener();
  }

  private initializeLanguageListener(): void {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateHtmlLangAttribute(event.lang);
    });
    this.updateHtmlLangAttribute(this.translateService.currentLang || 'en');
  }

  private updateHtmlLangAttribute(newLang: string): void {
    const htmlElement = this.document.querySelector('html');
    if (htmlElement) {
      this.renderer.setAttribute(htmlElement, 'lang', newLang);
    }
  }
}
